export const alphaSortObjectsByStringValue = (array, property) =>
  array
    .filter((obj) => Boolean(obj?.[property] && obj?.[property]?.trim()))
    .sort((a, b) => a[property].localeCompare(b[property]));
